var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "24px",
    viewBox: "0 0 26 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F405E765-A43A-4B97-81BE-CC117C8CC818") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Richr-Money",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ConnectBankAccount_ConnectedAccount_PopUp",
    transform: "translate(-103.000000, -161.000000)",
    fill: "#00D4A1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(59.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7142701,28.1428686 L49.7142701,29.0000109 C49.7142701,29.2367042 49.5223923,29.4285821 49.285699,29.4285821 L47.9999855,29.4285821 L47.9999855,30.0714388 C47.9999855,30.4264565 47.7121464,30.7142956 47.3571287,30.7142956 L26.3571414,30.7142956 C26.0021238,30.7142956 25.7142847,30.4264565 25.7142847,30.0714388 L25.7142847,29.4285821 L24.4285712,29.4285821 C24.1918778,29.4285821 24,29.2367042 24,29.0000109 L24,28.1428686 C24,27.9694768 24.104481,27.8131695 24.2646963,27.7468688 L36.6932602,23.0325859 C36.7981904,22.989138 36.9160798,22.989138 37.02101,23.0325859 L49.4495739,27.7468688 C49.6097892,27.8131695 49.7142701,27.9694768 49.7142701,28.1428686 Z M48.4285566,44.428573 L25.2857135,44.428573 C24.5756247,44.428573 24,45.0041976 24,45.7142865 L24,46.5714288 C24,46.8081222 24.1918778,47 24.4285712,47 L49.285699,47 C49.5223923,47 49.7142701,46.8081222 49.7142701,46.5714288 L49.7142701,45.7142865 C49.7142701,45.0041976 49.1386455,44.428573 48.4285566,44.428573 Z M28.2857117,31.5714379 L28.2857117,41.857146 L26.3571414,41.857146 C26.0021238,41.857146 25.7142847,42.1449851 25.7142847,42.5000027 L25.7142847,43.5714379 L47.9999855,43.5714379 L47.9999855,42.5000027 C47.9999855,42.1449851 47.7121464,41.857146 47.3571287,41.857146 L45.4285585,41.857146 L45.4285585,31.5714379 L41.9999891,31.5714379 L41.9999891,41.857146 L38.5714197,41.857146 L38.5714197,31.5714379 L35.1428504,31.5714379 L35.1428504,41.857146 L31.7142847,41.857146 L31.7142847,31.5714379 L28.2857117,31.5714379 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.e203e17fed53c1ce2f2757fd2dcbb767.svg";
export { ForwardRef as ReactComponent };